import React, { useEffect } from "react";
import { Routes, useLocation, useNavigate } from "react-router-dom";

const CheckpointRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
    const pathParts = location.pathname.split("/");
    const checkPointEncoded = pathParts[3];
    const decodedcheckPoint = atob(checkPointEncoded); // Decode Base64

  useEffect(() => {
    navigate(decodedcheckPoint);
  }, []); 

  return null; 
};

export default CheckpointRouter;
